import './styles.css';

import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import NotificationIcon from 'components/shared/NotificationIcon';
import { NOTIFICATION_STEPS } from 'utils/Constants';

function NotificationFilters({ filters, setFilters }) {
  const { t } = useTranslation();
  const [search, setSearch] = useState(filters.q);
  const timer = useRef(null);

  // Si l'URL change (retour arrière, reset), on resynchronise le champ.
  useEffect(() => {
    setSearch(filters.q);
  }, [filters.q]);

  useEffect(() => () => clearTimeout(timer.current), []);

  const handleChangeText = (e) => {
    const value = e.target.value;
    setSearch(value);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setFilters({ q: value.trim() }), 300);
  };

  return (
    <section className="notif-filters" aria-label={t('Filtres')}>
      <div className="notif-search">
        <label htmlFor="notif-search" className="notif-sr-only">
          {t('Rechercher une notification')}
        </label>
        <NotificationIcon name="search" size={18} />
        <input
          id="notif-search"
          type="search"
          placeholder={t('Rechercher (client, devis, objet…)')}
          autoComplete="off"
          value={search}
          onChange={handleChangeText}
        />
      </div>
      <div className="notif-chips" role="group" aria-label={t('Filtrer par étape')}>
        {NOTIFICATION_STEPS.map((s) => (
          <button
            key={s.id}
            type="button"
            className="notif-chip"
            aria-pressed={filters.step === s.id}
            onClick={() => setFilters({ step: s.id })}
          >
            {t(s.label)}
          </button>
        ))}
      </div>
    </section>
  );
}

export default NotificationFilters;
